import { MoreVert, Visibility } from '@mui/icons-material'
import { Divider, IconButton, ListItemIcon, ListItemText, Typography } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import React from 'react'
import { StyledMenu } from '../../styles/PopupStyles'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { StyledContainerRowCenter } from '../../styles/ContainerStyles'

const ReportsActionMenu = ({ navigationPath, label }: { navigationPath: string; label: string }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <>
      <PopupState variant="popover">
        {popupState => (
          <React.Fragment>
            <IconButton aria-label={'open-action-menu'} {...bindTrigger(popupState)} sx={{ color: 'inherit' }}>
              <MoreVert />
            </IconButton>

            <StyledMenu sx={{ maxWidth: '50px' }} {...bindMenu(popupState)}>
              <StyledContainerRowCenter
                sx={{
                  gap: 1,
                  py: 1,
                  px: 2,
                }}
                aria-disabled
              >
                <Typography variant="body2" fontWeight={700}>
                  {label}
                </Typography>
              </StyledContainerRowCenter>

              <Divider sx={{ my: 0.5 }} />
              <MenuItem onClick={() => navigate(navigationPath)} autoFocus>
                <ListItemIcon>
                  <Visibility />
                </ListItemIcon>
                <ListItemText>{t('page.projects.actionPopup.details')}</ListItemText>
              </MenuItem>
            </StyledMenu>
          </React.Fragment>
        )}
      </PopupState>
    </>
  )
}

export default ReportsActionMenu
